export default __webpack_public_path__ + "20a229ce8b3c76f068165d7c57b74fa4.otf";